<template>
<div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group">
        <Dropdown v-if="!loading" :class="[{ 'p-error' : error, 'show-eraser': showEraser, 'not-show-eraser': !showEraser }]" v-on="listeners" :id="uuid" :value="value" :options="options" :optionValue="optionValue" :optionLabel="optionLabel" placeholder="" :disabled="disable"/>
        <a v-if="showEraser" class="cursor-pointer p-col-1 p-md-1 p-lg-1" @click.prevent="modalPreventCleanup" style="margin-top: 30px;"><i class="fa-solid fa-eraser" :title="$t('menu.client.form')"/></a>
        <span v-if="error">{{ $t(errorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";
    import DialogService from "@/business/ModalBusiness";
    import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";

    export default {
        name: "CoffInputSelect",

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            disable: {type: Boolean, default: false},
            mask: {default: null},
            options: {type: Array,
                default() {
                    return [];
                }
            },
            optionLabel: {type: String, default: 'name'},
            optionValue: {type: String, default: null},
            translate: {type: Boolean, default: false},
            showEraser: {type: Boolean, default: false},
        },

        data(){
            return {
                uuid: Utils.uuid(),
                loading: true,
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
            if(this.translate){
                this.options.map(item => item[this.optionLabel] = this.$t(item[this.optionLabel]))
            }
            this.loading = false;
        },
        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    InputText: event => this.$emit('InputText', event.target.value)
                };
            },
        },

        methods: {
            async modalPreventCleanup(){
                if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
                    this.$emit('input', undefined);
                }
            }
        }

    }
</script>

<style scoped>

.show-eraser {
    width: 85%
}

.not-show-eraser {
    width: 100%
}

</style>
